import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "tui-search-input"
};
var _hoisted_2 = {
  "class": "tui-search-input-left"
};
var _hoisted_3 = ["placeholder"];
import { TUIStore, StoreName, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../adapter-vue";
import Icon from "../../common/Icon.vue";
import searchIcon from "../../../assets/icon/search.svg";
import closeIcon from "../../../assets/icon/input-close.svg";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    placeholder: {
      type: String,
      "default": function _default() {
        return TUITranslateService.t("TUISearch.搜索");
      }
    },
    searchType: {
      type: String,
      "default": "global",
      validator: function validator(value) {
        return ["global", "conversation"].includes(value);
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var searchValueModel = ref("");
    var _currentSearchInputValue = ref("");
    var searchingStatus = ref(false);
    TUIStore.watch(StoreName.CUSTOM, {
      currentSearchInputValue: function currentSearchInputValue(obj) {
        if ((obj === null || obj === void 0 ? void 0 : obj.searchType) === (props === null || props === void 0 ? void 0 : props.searchType)) {
          _currentSearchInputValue.value = obj === null || obj === void 0 ? void 0 : obj.value;
          searchValueModel.value = obj === null || obj === void 0 ? void 0 : obj.value;
        }
      },
      currentSearchingStatus: function currentSearchingStatus(obj) {
        if ((obj === null || obj === void 0 ? void 0 : obj.searchType) === (props === null || props === void 0 ? void 0 : props.searchType)) {
          searchingStatus.value = obj === null || obj === void 0 ? void 0 : obj.isSearching;
        }
      }
    });
    var search = function search() {
      // 避免重复搜索
      if (searchValueModel.value === _currentSearchInputValue.value) {
        return;
      }
      TUIStore.update(StoreName.CUSTOM, "currentSearchInputValue", {
        value: searchValueModel.value,
        searchType: props.searchType
      });
    };
    var endSearching = function endSearching() {
      searchingStatus.value = false;
      TUIStore.update(StoreName.CUSTOM, "currentSearchingStatus", {
        isSearching: false,
        searchType: props.searchType
      });
      TUIStore.update(StoreName.CUSTOM, "currentSearchInputValue", {
        value: "",
        searchType: props.searchType
      });
    };
    var onFocus = function onFocus() {
      TUIStore.update(StoreName.CUSTOM, "currentSearchingStatus", {
        isSearching: true,
        searchType: props.searchType
      });
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(Icon, {
        "class": "icon",
        file: _unref(searchIcon),
        width: "14px",
        height: "14px"
      }, null, 8, ["file"])]), _withDirectives(_createElementVNode("input", {
        "class": "tui-search-input-main",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(searchValueModel) ? searchValueModel.value = $event : null;
        }),
        placeholder: props.placeholder,
        onFocus: onFocus,
        onKeyup: _withKeys(search, ["enter"]),
        onConfirm: search,
        enterkeyhint: "search"
      }, null, 40, _hoisted_3), [[_vModelText, _unref(searchValueModel)]]), _unref(searchingStatus) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "tui-search-input-right",
        onClick: endSearching
      }, [_createVNode(Icon, {
        "class": "icon",
        file: _unref(closeIcon),
        width: "14px",
        height: "14px"
      }, null, 8, ["file"])])) : _createCommentVNode("", true)]);
    };
  }
});